<template>
    <!-- prettier-ignore -->
    <div class="signup-container">
        <div class="signup-bg"></div>
        <div class="signup-body">
            <div class="signup-box-header"></div>
            <div class="signup-box-body">
                <el-form class="signup-form-container" label-width="80px" :model="form" label-position="left">
                    <div class="form-header">
                        <div class="signup-title">注册一个账户</div>
                    </div>
                    <div class="signup-form-wrap">
                        <div class="signup-form" v-if="!signupComplete">
                            <div class="qrcode" v-if="!form.miniQrcodeToken">
                                <!-- 0  待扫描 1 已扫描 2 已授权 3 已拒绝 -->
                                <div class="qrcode-img" v-loading="!form.qrcode">
                                    <img :src="form.qrcode" alt="小程序码" />
                                    <div class="qrcode-status" v-if="['1', '3'].includes(form.qrcodeScanStatus)">
                                        <span v-if="form.qrcodeScanStatus == 1">扫描成功</span>
                                        <span v-else>失效了</span>
                                    </div>
                                </div>
                                <div class="qrcode-tips">首先，您需要使用微信扫描此小程序码</div>
                                <div v-if="form.qrcodeScanStatus == 3">
                                    <el-button type="text" @click="form.getMiniQrcode()">重新生成小程序码</el-button>
                                </div>
                            </div>
                            <div v-else>
                                <div style="margin-bottom: 20px;">接下来，请填写一些登录信息吧</div>
                                <div class="form-title">必填信息</div>
                                <el-form-item label="手机号" required :error="form.errors.phone">
                                    <el-input v-model="form.phone" placeholder="填写手机号码" maxlength="11"
                                        @change="form.errors = {}">
                                        <template v-slot:append>
                                            <el-button type="primary" :loading='form.captchaRequesting'
                                                v-if="!form.captchaCountDown" @click="form.getPhoneCaptcha()">发送验证码
                                            </el-button>
                                            <span v-else>{{ form.captchaCountDown }}秒</span>
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="验证码" required :error="form.errors.phoneCaptcha">
                                    <el-input v-model="form.phoneCaptcha" placeholder="填写验证码" maxlength="6"
                                        @change="form.errors = {}"></el-input>
                                </el-form-item>
                                <el-form-item label="密码" required :error="form.errors.password">
                                    <el-input type="password" autocomplete="new-password" v-model="form.password"
                                        placeholder="填写密码" @change="form.errors = {}"></el-input>
                                </el-form-item>
                                <el-form-item label="再输一次" required :error="form.errors.rePassword">
                                    <el-input type="password" autocomplete="new-password" v-model="form.rePassword"
                                        placeholder="填写再输一次密码" @change="form.errors = {}"></el-input>
                                </el-form-item>

                                <div class="add-more" v-if="!showMore" @click="showMore = true">+ 填写可选信息</div>

                                <template v-if="showMore">
                                    <div class="form-title">可选信息</div>
                                    <el-form-item label="昵称" :error="form.errors.name">
                                        <el-input v-model="form.name" placeholder="填写昵称，最长30个字符" maxlength="30"
                                            @change="form.errors = {}"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别" :error="form.errors.gender">
                                        <el-select v-model="form.gender" placeholder="请选择性别">
                                            <el-option v-for="item of genders" :key="item.value" :label="item.label"
                                                :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="头像" :error="form.errors.avatar">
                                        <el-avatar size="medium" :src="avatarUrl" icon="el-icon-user-solid"
                                            @click.native="chooseAvatar()"></el-avatar>
                                    </el-form-item>
                                </template>
                            </div>
                        </div>
                        <div v-else class="signup-form">
                            <div class="finish-tips">恭喜，您注册成功了！</div>
                        </div>
                    </div>

                    <div class="form-footer" v-if="form.miniQrcodeToken && !signupComplete">
                        <div>
                            <el-button type="primary" @click="signup()">立即注册</el-button>
                        </div>
                        <div class="policy-check">
                            <el-form-item :error="form.errors.privacyPolicy" label-width="0px">
                                <el-checkbox v-model="form.privacyPolicy" @change="form.errors = {}"></el-checkbox>
                                <span class="policy-tips">
                                    <span>请查看</span>
                                    <el-button type="text" @click="openPolicy()">《隐私政策》</el-button>
                                    <span>，确认后再注册账户</span>
                                </span>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="signup-box-footer">&copy;2022 ikrong.com</div>
        </div>
    </div>
</template>

<script>
import { SignupController } from "@/utils/auth/signup";
import Utils from "@/utils/utils";
import ImageCrop from "@/components/imageCrop/index";

export default {
    data() {
        const form = new SignupController();
        form.getMiniQrcode();
        return {
            form,
            avatarUrl: "",
            genders: [
                { label: "保密", value: 0 },
                { label: "男", value: 1 },
                { label: "女", value: 2 },
            ],
            showMore: false,
            signupComplete: false,
        };
    },
    created() {
    },
    methods: {
        async signup() {
            await this.form.validate();
            let { code, data } = await this.$api.form('/mm/user/signup', this.form.toJSON())
            // 注册成功
            this.$elementUI.message.success('注册成功')
            let info = new URL(location.href)
            if (info.searchParams.get('redirect')) {
                location.href = info.searchParams.get('redirect')
            }
        },
        openPolicy() {
            window.open(Utils.relativeURL("policy.html"), "_blank");
        },
        async chooseAvatar() {
            const file = await Utils.chooseFile(".jpg,.png");
            const avatar = await this.$openDialog(ImageCrop, {
                title: "剪裁头像",
                width: "580px",
                data: {
                    src: URL.createObjectURL(file),
                },
            });
            this.form.avatar = avatar;
            this.avatarUrl = URL.createObjectURL(avatar);
        },
    },
};
</script>

<style lang="scss" scoped>
.signup-container {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;

    .signup-bg {
        flex: auto;
        background-image: url(https://api-next.ikrong.com/ex/bingimg/view/now);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .signup-body {
        flex: 900px 0 0;
        display: flex;
        flex-direction: column;
        background-color: #fff;

        .signup-box-header {
            flex: 60px 0 0;
            padding-left: 100px;
        }

        .signup-box-body {
            flex: auto;
            overflow: hidden;
            overflow-y: auto;
            padding: 0 0 0 100px;

            >.signup-form-container {
                display: flex;
                flex-direction: column;
                height: 100%;

                .form-header {
                    flex: 55px 0 0;
                }

                .signup-form-wrap {
                    flex: auto;
                    overflow: auto;
                }

                .form-footer {
                    flex: 55px 0 0;
                    display: flex;
                    column-gap: 20px;
                    align-items: center;

                    .policy-check {
                        ::v-deep {
                            .el-form-item {
                                margin-bottom: 4px;

                                .el-form-item__error {
                                    padding-top: 0;
                                    margin-top: -10px;
                                }
                            }
                        }

                        .policy-tips {
                            margin-left: 1em;
                            color: #606266;
                        }
                    }
                }
            }

            .signup-title {
                font-size: 40px;
                font-weight: lighter;
                color: #323232;
            }

            .signup-form {
                padding-top: 20px;
                width: 500px;

                // 二维码
                .qrcode {
                    .qrcode-img {
                        width: 200px;
                        height: 200px;
                        position: relative;

                        >img {
                            width: 100%;
                            height: 100%;
                        }

                        .qrcode-status {
                            position: absolute;
                            width: 100px;
                            height: 40px;
                            padding: 0 20px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            top: 0;
                            left: 0;
                            bottom: 0;
                            right: 0;
                            margin: auto;
                            background-color: rgba(255, 255, 255, 0.8);
                            font-size: 14px;
                            white-space: nowrap;
                            overflow: hidden;
                            box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
                        }
                    }

                    .qrcode-tips {
                        margin: 10px 0;
                        font-size: 14px;
                    }
                }

                .finish-tips {
                    height: 30vh;
                    display: flex;
                    align-items: center;
                    font-weight: bold;
                }

                // 二维码结束
                // 表单
                .form-title {
                    padding: 10px 0 20px 0;
                    position: relative;
                    display: flex;
                    align-items: center;

                    &::before {
                        content: "";
                        display: inline-block;
                        border-left: 0.4em solid #409eff;
                        height: 1em;
                        margin-right: 0.5em;
                    }
                }

                .add-more {
                    font-size: 14px;
                    color: #419dfb;
                    cursor: pointer;
                    margin-bottom: 20px;
                }


                // 表单结束
            }
        }

        .signup-box-footer {
            flex: 60px 0 0;
            padding-left: 100px;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #b0b0b0;
        }
    }
}
</style>